import { useQuery } from "@tanstack/react-query";

import { getMultiPlatformList } from "api/methods";
import { Models } from "api/types";

type UsePlatformDomainTokensResult = {
  platformDomainTokens?: Models<"GetMultiPlatformUserPlatformResult">[];
};

export const usePlatformDomainTokens = (): UsePlatformDomainTokensResult => {
  const { data } = useQuery({
    ...getMultiPlatformList.keyed(),
    staleTime: 1000 * 60 * 2,
  });

  return { platformDomainTokens: data?.platformDomainTokens };
};
